import { StyleSheet } from 'react-native';

export const Styles = StyleSheet.create({
  container: {
    width: '100%',
    position: 'relative',
  },
});
